import { Card, CardContent, CardHeader, CardTitle } from '@/components/card'
import { Progress } from '@/components/progress'
import { Button } from '@/components/ui/common/Button'
import { cn } from '@/utils'
import { Signal } from './GoNoGoTask'

interface GoNoGoChoiceProps {
  currentTrial: number
  totalTrials: number
  currentSignal: Signal
  responded: boolean
  handleResponse: () => void
  remainingTime: number
  className?: string
}

export default function GoNoGoChoice({
  currentTrial,
  totalTrials,
  currentSignal,
  responded,
  handleResponse,
  remainingTime,
  className
}: GoNoGoChoiceProps) {
  const formatTime = (ms: number) => {
    const seconds = Math.ceil(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  return (
    <div className="relative">
      {currentSignal && (
        <div className="absolute -top-8 right-0 rounded-md bg-transparent px-3 py-1 text-sm font-medium text-gray-600">
          Pozostały czas: {formatTime(remainingTime)}
        </div>
      )}
      <Card className={cn('mx-auto w-full max-w-md', className)}>
        <CardHeader>
          <CardTitle className="text-center">
            Próba {currentTrial} z {totalTrials}
          </CardTitle>
          <Progress className="w-full" max={totalTrials} value={currentTrial} />
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-6">
          <div className="flex h-40 w-40 items-center justify-center rounded-md border">
            {currentSignal && (
              <div
                className={cn(
                  'flex h-32 w-32 items-center justify-center rounded-full',
                  currentSignal === 'GO' ? 'bg-[#2bcaca]' : 'bg-red-500'
                )}
              >
                <span className="text-3xl font-bold text-white">{currentSignal}</span>
              </div>
            )}
          </div>

          <Button
            className="w-32 bg-[#2bcaca] hover:bg-[#2b9999]"
            disabled={responded}
            onClick={handleResponse}
          >
            Kliknij!
          </Button>

          <p className="text-center text-sm text-gray-500">
            Kliknij przycisk tylko gdy widzisz "GO"
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
